// WARNING: This is a place for TEMPORARY changes
// - everything in this file should move to WPS
// - everything in this file should have a corresponding SIM with a "tech-debt" label
export default function transform(response: { [key: string]: any }) {
  const mappers: Function[] = [
    mapPageNumber
  ]
  return mappers.reduce((acc, mapper) => {
    try {
      return mapper(acc)
    } catch (e) {
      console.error(e)
      return acc
    }
  }, response)
}

// TODO(AVWebStorefront-1341): Needs to be moved to WPS
function mapPageNumber(response: { pageNumber: number; pagination: { page: any; }; }) {
  response.pageNumber = response.pagination &&
    response.pagination.page ? response.pagination.page : 1
  return response
}
